import React from 'react';

import { useClassnames } from '@lumapps/classnames';
import { useDataAttributes } from '@lumapps/data-attributes';
import { Typography, Theme } from '@lumapps/lumx/react';
import { UserBlock } from '@lumapps/user-ui/components/UserBlock';
import { UserDetailedFields } from '@lumapps/user-ui/components/UserDetailedFields';
import { useBlockBreakpoints } from '@lumapps/widget-base/hooks/useBlockBreakpoints';
import { BlockComponent } from '@lumapps/widget-base/types';

import { BlockUserProfilePreview as BlockUserProfilePreviewProps } from '../types';

import './index.scss';

const CLASSNAME = 'block-user-profile-preview';

export const BlockUserProfilePreview: BlockComponent<BlockUserProfilePreviewProps> = ({
    fields,
    userId,
    pictureUrl,
    // eslint-disable-next-line deprecation/deprecation
    fullName,
    jobTitle,
    theme = Theme.light,
}) => {
    const { block, element } = useClassnames(CLASSNAME);
    const { get } = useDataAttributes(CLASSNAME);
    const { currentBreakpoint, ref } = useBlockBreakpoints();

    return (
        <UserBlock
            className={block()}
            {...get({ element: 'block', action: userId })}
            theme={theme}
            ref={ref}
            user={{
                id: userId,
                fullName,
            }}
            additionalFields={jobTitle ? [jobTitle] : undefined}
            fields={[]}
            customUserAvatar={pictureUrl}
            nameProps={{
                typography: Typography.custom.title5,
            }}
            afterFields={
                <UserDetailedFields
                    className={element('user-fields', {
                        [`${currentBreakpoint}`]: Boolean(currentBreakpoint),
                    })}
                    theme={theme}
                    fields={fields}
                    getAdditionalUserDetailedFieldProps={() => ({
                        className: element('field'),
                    })}
                />
            }
        />
    );
};
